module.exports = __webpack_public_path__ + "IcoReq_Hos.png";